import "./Slider.styles.css";

import { forwardRef, type PropsWithChildren, useState } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { SliderProps } from "./Slider.types";

const Slider = forwardRef<HTMLInputElement, PropsWithChildren<SliderProps>>(
  ({ className, ...sliderProps }, forwardedRef) => {
    const [value, setValue] = useState(50);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setValue(Number(e.target.value));
    };

    return (
      <input
        ref={forwardedRef}
        type="range"
        className={cn(
          "slider h-[4px] w-80 appearance-none rounded-lg",
          className,
        )}
        onInput={handleInputChange}
        style={{
          background: `linear-gradient(to right, #556AEB 0%, #556AEB ${value}%, #737373 ${value}%, #737373 100%)`,
        }}
        {...sliderProps}
      />
    );
  },
);

Slider.displayName = "Slider";

export default Slider;
